import { Counter, Reveal, SectionHeading } from "./Motion";

const COUNTERS = [
  { id: "since", to: 2011, plain: true, label: "Founded" },
  { id: "years", to: 16, suffix: "+", label: "Years Experience" },
  { id: "customers", to: 10000, suffix: "+", label: "Happy Customers" },
  { id: "brands", to: 40, suffix: "+", label: "Trusted Brands" },
];

const MILESTONES = [
  { y: "2011", t: "Started in Unnao" },
  { y: "Step 2", t: "Rooftop solar for homes" },
  { y: "Step 3", t: "Schools, farms, hospitals" },
  { y: "Step 4", t: "Industrial Projects + Finance" },
  { y: "Today", t: "10,000+ happy customers" },
];

export const Journey = () => (
  <section id="journey" data-testid="journey-section" className="section-pad relative overflow-hidden bg-[linear-gradient(135deg,#0B132B_0%,#121C3A_55%,#1B2750_100%)]">
    <div className="pointer-events-none absolute -left-40 top-20 h-96 w-96 rounded-full bg-gold/20 blur-[120px]" />
    <div className="relative container-x">
      <SectionHeading dark eyebrow="Our Journey" title="16 Years of Growing Trust" />
      <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {COUNTERS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.1}>
            <div className="rounded-3xl border border-white/10 bg-white/[0.06] p-6 sm:p-8 backdrop-blur">
              <div className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gold-bright">
                <Counter to={c.to} suffix={c.suffix} plain={c.plain} testId={`journey-counter-${c.id}`} />
              </div>
              <div className="mt-2 text-base sm:text-lg text-slate-300">{c.label}</div>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="relative mt-16">
        <div className="absolute left-[11px] top-2 bottom-2 w-px bg-gradient-to-b from-gold via-gold/40 to-transparent lg:left-0 lg:right-0 lg:top-[11px] lg:bottom-auto lg:h-px lg:w-auto lg:bg-gradient-to-r" />
        <ol className="grid gap-8 lg:grid-cols-5 lg:gap-6">
          {MILESTONES.map((m, i) => (
            <Reveal key={m.t} delay={i * 0.12}>
              <li data-testid={`timeline-item-${i}`} className="relative pl-10 lg:pl-0 lg:pt-10">
                <span className={`absolute left-0 top-0.5 h-6 w-6 rounded-full border-4 border-navy-900 ${i === 0 || i === 4 ? "bg-gold shadow-[0_0_20px_#f59e0b]" : "bg-slate-500"}`} />
                <div className="font-display text-lg font-bold text-gold-light">{m.y}</div>
                <div className="mt-1 text-xl font-semibold text-white">{m.t}</div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
